var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-container-search-bar"},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('p',{staticClass:"mon-bold f-s45 l-spacing0 mb-0 "},[_vm._v(" "+_vm._s(_vm.nameScreen)+" ")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }